import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import WalmartEnrollmentFilterRenderer from 'flow-doctor-lib/components/filters/WalmartEnrollmentFilterRenderer';
import { BATCH_CONVERT_CLS_FILTERS_TO_ILS } from 'flow-doctor-lib/queries/FilterQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicEnrollmentFilterRenderer = ({
  portalId,
  objectTypeId,
  filters,
  condensed
}) => {
  // We only support ILS filters, so use the BE to convert CLS --> ILS first
  const {
    data,
    loading,
    error
  } = useQuery(BATCH_CONVERT_CLS_FILTERS_TO_ILS, {
    variables: {
      filters,
      portalId
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "badRequest",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.highlights.filtersConversionError.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.highlights.filtersConversionError.description_jsx",
        elements: {
          Link: UILink
        },
        options: {
          teamName: 'Automation Triggers FE',
          external: true,
          href: 'https://hubspot.slack.com/archives/C01MWLFE12Q'
        }
      })
    });
  }
  if (loading || !data) return /*#__PURE__*/_jsx(UILoadingSpinner, {
    className: "m-bottom-6",
    layout: "centered"
  });
  return /*#__PURE__*/_jsx(WalmartEnrollmentFilterRenderer, {
    objectTypeId: objectTypeId,
    filterBranch: data.batchClsToIls,
    condensed: condensed,
    filterWidthType: condensed ? 'LIST_FIXED' : 'LIST_STRETCHED'
  });
};
export default ClassicEnrollmentFilterRenderer;